(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const swatch = event.target.closest('[data-card-swatch]');
    if (!swatch) return;

    const card = swatch.closest('.product-card');
    const image = card.querySelector('.product-card__image--primary');
    if (image && swatch.dataset.src) {
      image.srcset = swatch.dataset.srcset;
      image.src = swatch.dataset.src;
    }
    card.querySelectorAll('[data-card-swatch]').forEach((item) => {
      item.setAttribute('aria-pressed', String(item === swatch));
    });
    card.querySelectorAll('[data-card-link]').forEach((link) => {
      link.href = swatch.dataset.url;
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    class ProductGallery {
    constructor(container) {
      this.container = container;
      this.slides = container.querySelectorAll('.product-gallery__slide');
      this.thumbs = container.querySelectorAll('.product-gallery__thumb');
      this.prevBtn = container.querySelector('[data-gallery-prev]');
      this.nextBtn = container.querySelector('[data-gallery-next]');
      this.zoomTriggers = container.querySelectorAll('[data-zoom-trigger]');
      this.zoomModal = document.querySelector('[data-zoom-modal]');
      this.currentIndex = 0;

      this.init();
    }

    init() {
      // Thumbnail clicks
      this.thumbs.forEach((thumb, index) => {
        thumb.addEventListener('click', () => this.goTo(index));
      });

      // Navigation
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => this.prev());
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => this.next());
      }

      // Zoom
      this.zoomTriggers.forEach(trigger => {
        trigger.addEventListener('click', (e) => this.openZoom(e));
      });

      if (this.zoomModal) {
        this.zoomModal.querySelector('[data-zoom-close]').addEventListener('click', () => this.closeZoom());
        this.zoomModal.addEventListener('click', (e) => {
          if (e.target === this.zoomModal) this.closeZoom();
        });
      }

      // Keyboard navigation
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.zoomModal && !this.zoomModal.hidden) {
          this.closeZoom();
        }
      });
    }

    goTo(index) {
      this.slides[this.currentIndex].classList.remove('is-active');
      this.thumbs[this.currentIndex]?.classList.remove('is-active');

      this.currentIndex = index;

      this.slides[this.currentIndex].classList.add('is-active');
      this.thumbs[this.currentIndex]?.classList.add('is-active');

      // Scroll thumb into view
      this.thumbs[this.currentIndex]?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    prev() {
      const newIndex = this.currentIndex === 0 ? this.slides.length - 1 : this.currentIndex - 1;
      this.goTo(newIndex);
    }

    next() {
      const newIndex = this.currentIndex === this.slides.length - 1 ? 0 : this.currentIndex + 1;
      this.goTo(newIndex);
    }

    openZoom(e) {
      const img = e.target.closest('.product-gallery__image-wrapper').querySelector('.product-gallery__image');
      const zoomSrc = img.dataset.zoomSrc || img.src;
      
      this.zoomModal.querySelector('[data-zoom-image]').src = zoomSrc;
      this.zoomModal.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    closeZoom() {
      this.zoomModal.hidden = true;
      document.body.style.overflow = '';
    }

    // Update gallery when variant changes
    updateForVariant(variantMediaId) {
      if (!variantMediaId) return;
      
      const index = Array.from(this.slides).findIndex(
        slide => slide.dataset.mediaId == variantMediaId
      );
      
      if (index !== -1) {
        this.goTo(index);
      }
    }
  }

  // Initialize
  document.querySelectorAll('[data-product-gallery]').forEach(gallery => {
    new ProductGallery(gallery);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-media"] && !Shopify.designMode) return;
  try {
    class ProductMedia {
    constructor(el) {
      this.container = el;
      this.list = el.querySelector('[data-media-list]');
      this.dots = Array.from(el.querySelectorAll('[data-media-dot]'));

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.scrollToPosition(Number(dot.dataset.mediaDot)));
      });

      let frame = null;
      this.list.addEventListener('scroll', () => {
        if (frame) return;
        frame = requestAnimationFrame(() => {
          frame = null;
          this.updateDots();
        });
      }, { passive: true });
    }

    items() {
      return Array.from(this.list.querySelectorAll('[data-media-index]'));
    }

    isSlider() {
      return getComputedStyle(this.list).display === 'flex';
    }

    currentPosition() {
      const width = this.list.clientWidth || 1;
      return Math.round(this.list.scrollLeft / width);
    }

    updateDots() {
      const position = this.currentPosition();
      this.dots.forEach((dot, index) => {
        if (index === position) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    scrollToPosition(position) {
      this.list.scrollTo({ left: position * this.list.clientWidth, behavior: 'smooth' });
    }

    /* The chosen variant's image becomes the first (hero) image; the rest keep their order */
    selectByMediaId(mediaId) {
      const items = this.items();
      const selected = items.find((item) => item.dataset.mediaId === String(mediaId));
      if (!selected) return;

      items
        .sort((a, b) => Number(a.dataset.mediaIndex) - Number(b.dataset.mediaIndex))
        .forEach((item) => this.list.appendChild(item));
      this.list.prepend(selected);

      if (this.isSlider()) {
        this.list.scrollTo({ left: 0, behavior: 'auto' });
        this.updateDots();
      } else if (selected.getBoundingClientRect().top < 0) {
        this.container.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }

  document.querySelectorAll('[data-product-media]').forEach((el) => {
    el.productMedia = new ProductMedia(el);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["size-guide"] && !Shopify.designMode) return;
  try {
    (function() {
    const dialog = document.getElementById('size-guide-dialog');
    if (!dialog) return;

    const closeBtn = dialog.querySelector('.size-guide-dialog__close');
    
    // Close on button click
    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        dialog.close();
      });
    }

    // Close on backdrop click
    dialog.addEventListener('click', (e) => {
      if (e.target === dialog) {
        dialog.close();
      }
    });

    // Close on Escape key
    dialog.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        dialog.close();
      }
    });

    // Expose open function globally
    window.openSizeGuide = function() {
      dialog.showModal();
    };
  })();
  } catch(e) { console.error(e); }
})();

})();
